export enum DocumentConfigurationEnum {
  Defualt = 1,
  PersonalPhoto = 2,
  Documents = 3,
  DocumentsOrImage = 4
}
